/* eslint-disable max-statements */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface DownloadDocumentProps {
  importerId: string;
  fileName: string;
}

export const useDownloadDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ importerId, fileName }: DownloadDocumentProps) => {
      const result = await apiClient.importer.downloadDocument.query({ params: { id: importerId, fileName } });
      if (result.status !== 200) throw result.body;

      const blob = result.body as Blob;
      const contentDisposition = result.headers.get('content-disposition') ?? '';
      const downloadFileName = /filename="([^"]*)"/.exec(contentDisposition)?.[1] ?? fileName;

      const href = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', downloadFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(href);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['importer', variables.importerId] });
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading document!`);
    },
  });
};
